import Link from 'next/link';
import { SvgAcademyLogo } from 'components/Svgs';
import SC from './style';

interface LogoProps {
  margin?: any;
  color?: any;
}

const Logo: React.FC<LogoProps> = ({ margin, color }) => (
  <Link href="/mon-academy" shallow passHref legacyBehavior>
    <SC.AnchorLogo margin={margin}>
      <SvgAcademyLogo color={color} />
    </SC.AnchorLogo>
  </Link>
);

export default Logo;
